module.exports = __webpack_public_path__ + "static/media/ImageTesting_elBanner982162_1920_187959.33da3615.jpg";